import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { PaymentTypes } from "../../../../common/enums";
import { useEffect } from "react";
import {
  eventArrivalConfirmationDefaultValues,
  eventArrivalConfirmationFormSchema,
  IEventArrivalConfirmationFormModel,
} from "../models/eventArrivalConfirmationFormModel";
import { IEventArrivalConfirmationViewModel } from "../models/eventArrivalConfirmationViewModel";

export const useEventArrivalConfirmationForm = (
  isLoading: boolean,
  paymentOptions?: PaymentTypes[],
  item?: IEventArrivalConfirmationViewModel
) => {
  const form = useForm<IEventArrivalConfirmationFormModel>({
    defaultValues: eventArrivalConfirmationDefaultValues,
    resolver: yupResolver(eventArrivalConfirmationFormSchema),
  });

  useEffect(() => {
    const selectedPaymentType = Number(item?.selectedPaymentType ?? 0);

    if (selectedPaymentType === PaymentTypes.Deposit) {
      // Deposit (900) is never a studio-configured tender, so it can never be
      // in paymentOptions — but a reservation already paid from the deposit
      // MUST keep it. Falling back to the first configured method here would
      // silently re-tender the class while the ledger Spend row stays, i.e.
      // charge the client twice.
      form.setValue("paymentTypeId", PaymentTypes.Deposit);
    } else if (paymentOptions?.includes(selectedPaymentType)) {
      form.setValue("paymentTypeId", selectedPaymentType);
    } else if (paymentOptions) {
      form.setValue("paymentTypeId", paymentOptions[0]);
    }

    if (item) {
      form.setValue("eventId", item.eventId);
      form.setValue("userId", item.user.id);
      // A reservation already paid from the deposit must re-submit the amount
      // actually debited, not the class list price: the backend reconciles the
      // difference, so the list price would charge the client a second time.
      form.setValue(
        "price",
        selectedPaymentType === PaymentTypes.Deposit
          ? item.pricePaid ?? item.eventPrice
          : item.eventPrice
      );
      form.setValue(
        "subscriptionId",
        item.subscriptions?.length > 0 ? item.subscriptions[0].id : 0
      );
    }
  }, [isLoading, item]);
  return form;
};
